import React from 'react';
import { ArticlePage, ArticleTypes } from './models';

interface Props {
	article: ArticlePage;
	setVideo: any;
	showDatesAndCategory: boolean;
}

export const ArticleListView = (props: Props) => {

	const { article, setVideo, showDatesAndCategory } = props;
	const onClick = () => {
		setVideo(article?.videoUrl);
	};

	const renderLink = (articleType: string) => {
		switch (articleType) {
			case ArticleTypes.Article:
				return <a href={article?.externalUrl || article?.pageUrl} target={article?.externalUrl ? '_blank' : '_self'} ><strong>{article?.articleTitle}</strong></a>;
			case ArticleTypes.StandardLink:
				return <a href={article?.externalUrl || article?.pageUrl} target={article?.externalUrl ? '_blank' : '_self'} ><strong>{article?.articleTitle}</strong></a>;
			case ArticleTypes.ExternalLink:
				return <a href={article?.externalUrl || article?.pageUrl} target={article?.externalUrl ? '_blank' : '_self'} ><strong>{article?.articleTitle}</strong></a>;
			case ArticleTypes.Video:
				return <button className='topic-list-video-button' type='button' onClick={onClick} ><strong>{article?.articleTitle}</strong></button>;
			case ArticleTypes.PDF:
				return <a href={article?.externalUrl || article?.pdfUrl} target='_blank' ><strong>{article?.articleTitle}</strong></a>;
		}
	}
	const renderIcon = (articleType: string) => {
		switch (articleType) {
			case ArticleTypes.Article:
				return '#article-icon';
			case ArticleTypes.Video:
				return '#video-play';
			case ArticleTypes.PDF:
				return '#pdf-icon-mui';
			case ArticleTypes.StandardLink:
				return '#share-link-icon';
			case ArticleTypes.ExternalLink:
				return '#icon-external-link';
		}
	}
	return (
		<div className='topic-list '>
			<div className='topic-list-cell'>
				{showDatesAndCategory && <p>{article?.date}</p>}
			</div>
			<div className='topic-list-cell topic-list-cell-large'>
				{renderLink(article?.articleType)}
			</div>
			<div className='topic-list-cell'>
				{showDatesAndCategory && <p>{article?.category}</p>}
			</div>
			<div className='topic-list-cell'>
				<p className='topic-list-type'><svg className='topic-list-type-icon' aria-hidden='true' focusable='false'>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref={renderIcon(article?.articleType)} />
				</svg>
					{article?.articleType}</p>
			</div>
		</div>
	);

};